// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Dict from "@rescript/core/src/Core__Dict.bs.js";

let eventListenerMap = {};

function addSmartEventListener(type_, handlerMethod, activity) {
  let value = eventListenerMap[activity];
  if (value !== undefined) {
    window.removeEventListener(type_, value);
  }
  eventListenerMap[activity] = handlerMethod;
  window.addEventListener(type_, handlerMethod);
}

function removeSmartEventListener(type_, activity) {
  let handlerMethod = eventListenerMap[activity];
  if (handlerMethod !== undefined) {
    window.removeEventListener(type_, handlerMethod);
    return Core__Dict.$$delete(eventListenerMap, activity);
  }
}

export {
  eventListenerMap,
  addSmartEventListener,
  removeSmartEventListener,
}
/* No side effect */
